"use strict";

import axios from "axios";
import GlobalError from "../helpers/globalError";

export default class PublicationsTable {
	constructor() {
		this.selectedLocale = document.querySelector('#dropdownlanguageMenu');
		this.selectCountry = document.querySelector('#selectMapCountry');
		this.containerFilter = document.querySelector('#award-filter-data-holder');
	}
	
	/**
	 * Get only country list where publications exist
	 */
	getCountryList() {
		axios.post(`/${ this.selectedLocale.dataset.languageSelected }/map/get-country-list`, {
				params: {
					locale: this.selectedLocale.dataset.languageSelected,
					publication: true
				}
			})
			.then((response) => {
				const controlSelectCountry = this.selectCountry.tomselect;
				controlSelectCountry.addOptions(response.data.data.ispAvailable);
				
				const urlParams = new URLSearchParams(window.location.search);
				
				const countrySelection = urlParams.get('country');
				if (countrySelection) {
					controlSelectCountry.setValue(countrySelection);
				}
			})
			.catch(function (error) {
				if (error.response && error.response.data.errors) {
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalPublicationTable');
				}
			});
		
	}
	
	/**
	 * Get only country list where publications exist
	 * @param shouldResetPage - boolean - detect if publication should be resetting at firs page
	 * @param loaderId
	 * @param containerTableId
	 * @param containerFilerElement
	 */
	refreshPublicationsTable(shouldResetPage = true, loaderId = '#loaderTable', containerTableId = '#tableContainer', containerFilerElement = this.containerFilter) {
		const loader = document.querySelector(loaderId);
		loader.classList.remove('d-none');
		
		let filtersElement = containerFilerElement;
		
		if (!filtersElement) {
			filtersElement = document.querySelector('#award-filter-data-holder');
		}
		
		const typeFilters = {
			coverageSelected: `${ filtersElement.dataset.coverageSelected }`,
			fixedSelected: `${ filtersElement.dataset.fixedSelected }`,
			cellularSelected: `${ filtersElement.dataset.cellularSelected }`,
			wifiSelected: `${ filtersElement.dataset.wifiSelected }`,
		}
		const isAllFilterDisable = (currentValue) => currentValue === "false";
		
		axios.post(`/${ this.selectedLocale.dataset.languageSelected }/index/publications-table`, {
					country: filtersElement.dataset.countrySelected,
					page: shouldResetPage ? 1 : filtersElement.dataset.pageSelected,
					typeFilters: Object.values(typeFilters).every(isAllFilterDisable) ? null : typeFilters
				}
			)
			.then((response) => {
				const tableElement = document.querySelector(containerTableId);
				
				tableElement.innerHTML = response.data;
				
				const paginationList = document.querySelectorAll(`${ containerTableId } .page-selector-button`);
				const containerRankingTableList = document.querySelectorAll('.table-responsive');
				
				[...paginationList].forEach((pageButton) => {
					pageButton.addEventListener('click', () => {
						this.changePage(pageButton.getAttribute('value'), loaderId, containerTableId);
					});
				});
				
				containerRankingTableList.forEach((containerRankingTable) => {
					const containerTable = containerRankingTable.closest('.container-table');
					containerRankingTable.addEventListener('scroll', () => {
						const bodyRTL = document.querySelector('body[dir="rtl"]');
						if (bodyRTL) {
							if (containerRankingTable.scrollLeft >= 1) {
								containerTable.classList.remove('scroll-table-right');
							} else if ((containerRankingTable.scrollLeft - containerRankingTable.getBoundingClientRect().width) === -(containerRankingTable.querySelector('.table').scrollWidth - 1)) {
								containerTable.classList.remove('scroll-table-left');
							} else {
								containerTable.classList.add('scroll-table-right', 'scroll-table-left');
							}
						} else {
							if (containerRankingTable.scrollLeft === 0) {
								containerTable.classList.remove('scroll-table-left');
							} else if ((containerRankingTable.scrollLeft + containerRankingTable.getBoundingClientRect().width) === containerRankingTable.querySelector('.table').scrollWidth) {
								containerTable.classList.remove('scroll-table-right');
							} else {
								containerTable.classList.add('scroll-table-right', 'scroll-table-left');
							}
						}
						
					})
				})
				
			})
			.catch(function (error) {
				loader.classList.add('d-none');
				if (error.response && error.response.data.errors) {
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalPublicationTable');
				}
			})
			.finally(function () {
				loader.classList.add('d-none');
			});
		
	}
	
	/**
	 * refresh table filter by country selected
	 * @param countryCode - string - detect if pagination should be resetting
	 */
	setCountryFilter(countryCode) {
		this.containerFilter.dataset.countrySelected = countryCode;
		this.refreshPublicationsTable(true);
	}
	
	/**
	 * set all filter depending on country and publication type
	 */
	setFiltersState() {
		const tableElement = document.querySelector('#award-filter-data-holder');
		const btnCoverage = document.querySelector('#filterCoverage');
		const btnFixed = document.querySelector('#filterFixed');
		const btnCellular = document.querySelector('#filterCellular');
		const btnWifi = document.querySelector('#filterWifi');
		
		tableElement.dataset.coverageSelected = btnCoverage.dataset.selected;
		tableElement.dataset.fixedSelected = btnFixed.dataset.selected;
		tableElement.dataset.cellularSelected = btnCellular.dataset.selected;
		tableElement.dataset.wifiSelected = btnWifi.dataset.selected;
		
		const typeFilters = {
			coverage: JSON.parse(`${ tableElement.dataset.coverageSelected }`),
			fixed: JSON.parse(`${ tableElement.dataset.fixedSelected }`),
			cellular: JSON.parse(`${ tableElement.dataset.cellularSelected }`),
			wifi: JSON.parse(`${ tableElement.dataset.wifiSelected }`),
		}
		const trueTypeFilters = Object.keys(typeFilters).filter(key => typeFilters[key] === true);
		const seperatedType = trueTypeFilters.join(',');
		this.updateUrlPublication('type', seperatedType);
	}
	
	/**
	 * pagination on click on page button
	 * @param pageNumber - number
	 * @param loaderId - string
	 * @param containerTableId - string
	 */
	changePage(pageNumber = 1, loaderId, containerTableId) {
		this.containerFilter.dataset.pageSelected = pageNumber;
		this.refreshPublicationsTable(false, loaderId, containerTableId);
		this.updateUrlPublication('page', pageNumber);
	}
	
	/**
	 * enable filter button on click
	 * @param filterButton - Object
	 * @param needRefreshTable
	 */
	enableFilterButton(filterButton, needRefreshTable = false) {
		filterButton.classList.toggle('active');
		filterButton.dataset.selected = `${ !JSON.parse(filterButton.dataset.selected) }`;
		const authorizedTypes = ["fixed", "cellular", "coverage", "wifi"];
		if (authorizedTypes.includes(filterButton.dataset.type)) {
			this.setFiltersState();
			if (needRefreshTable) {
				this.refreshPublicationsTable(false);
			}
		}
	}
	
	/**
	 * update current url depending on filter type
	 * @param paramQueryType name of the query parameter
	 * @param newValue value to set
	 */
	updateUrlPublication(paramQueryType, newValue = null) {
		
		const urlParams = new URLSearchParams(window.location.search);
		
		if (!newValue && urlParams.get(paramQueryType)) {
			urlParams.delete(paramQueryType);
		} else {
			urlParams.set(paramQueryType, newValue);
		}
		
		history.replaceState({}, "", decodeURIComponent(`${ window.location.pathname }?${ urlParams }`));
	}
	
}
